var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInstagram = function SvgInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "instagram_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "instagram_svg__linear-gradient",
    x1: 0,
    y1: 32,
    x2: 30,
    y2: 2,
    gradientTransform: "matrix(1 0 0 -1 0 32)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4f5bd5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.233,
    stopColor: "#962fbf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.516,
    stopColor: "#d62976"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.715,
    stopColor: "#fa7e1e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feda75"
  })), /*#__PURE__*/React.createElement("style", null, ".instagram_svg__st1{fill:#fff;fill-rule:evenodd}"), /*#__PURE__*/React.createElement("mask", {
    id: "instagram_svg__mask",
    x: 5.8,
    y: 6.388,
    width: 18.396,
    height: 17.396,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    className: "instagram_svg__st1",
    d: "M5.8 6.388h18.396v17.396H5.8V6.388Z",
    id: "instagram_svg__mask0_2_986"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M26.4 0H3.6C1.56 0 0 1.559 0 3.6v22.8C0 28.44 1.559 30 3.6 30h22.8c2.039 0 3.6-1.559 3.6-3.6V3.6C30 1.56 28.441 0 26.4 0Z",
    style: {
      fill: "url(#instagram_svg__linear-gradient)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "instagram_svg__st1",
    d: "M15 7.202h-4.72c-.225 0-.45.015-.673.056a3.544 3.544 0 0 0-1.923 1.005 3.57 3.57 0 0 0-1.07 2.6c-.002 2.815 0 5.63 0 8.444a3.646 3.646 0 0 0 2.262 3.394c.45.183.919.267 1.405.266 1.066-.002 2.131 0 3.197 0h6.207c.296 0 .589-.023.877-.09a3.637 3.637 0 0 0 2.82-3.54v-8.51c0-.24-.02-.476-.072-.708-.244-1.119-.869-1.954-1.872-2.5a3.526 3.526 0 0 0-1.713-.417h-4.726ZM15 23.782c-1.606 0-3.213.008-4.819-.004-1.108-.008-2.079-.397-2.905-1.136a4.37 4.37 0 0 1-1.343-2.233 4.124 4.124 0 0 1-.13-1.01v-4.566c0-1.349-.01-2.698.003-4.047.011-1.234.474-2.285 1.352-3.147a4.335 4.335 0 0 1 2.323-1.186c.26-.046.523-.064.787-.064h9.45c.889 0 1.71.229 2.453.72 1 .66 1.637 1.581 1.914 2.75.076.324.108.654.109.987 0 2.826.002 5.652-.001 8.478a4.446 4.446 0 0 1-2.614 4.065 4.186 4.186 0 0 1-1.358.366 5.64 5.64 0 0 1-.515.025c-1.569.002-3.137.001-4.706.001Z",
    style: {
      mask: "url(#instagram_svg__mask)"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "instagram_svg__st1",
    d: "M14.998 18.777c2.097 0 3.797-1.7 3.796-3.795a3.797 3.797 0 0 0-3.8-3.792 3.796 3.796 0 0 0-3.788 3.795 3.796 3.796 0 0 0 3.792 3.792Zm4.601-3.79a4.6 4.6 0 1 1-9.2-.007 4.6 4.6 0 0 1 9.2.007ZM19 9.983a1 1 0 1 1 2 .002 1 1 0 0 1-2-.002Z"
  })));
};
export default SvgInstagram;